const TStrings = {
    DIALOG_ICON_TOOLTIP: 'Download the signed document',
    LOCK_ICON_TOOLTIP:
        'Forms with signatures cannot be edited for security reasons.',
    SIGNATURE_INVALID: 'Invalid Signature (file may be tampered with)',
    SIGNATURE_UNSIGNED: 'Form contains signature',
};

export default TStrings;
